import React, { useEffect, useMemo, useState, useCallback } from "react";
import { CircularProgress, Typography } from "@mui/material";
import Order from "./Order";
import DetailsModal from "./DetailsModal";
import Logger from "./Logger";
import PaginationControls from "../Component/Pagination";
import "../Css/Assigned.css";
import { FaListUl } from "react-icons/fa";
import { getLoggerBaseURL } from "../utils/getLoggerBaseURL";

function Assigned() {
  const userEmail = sessionStorage.getItem("userEmail");
  const [orders, setOrders] = useState([]);
  const [selectedOption, setSelectedOption] = useState("OrderNo");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showDModal, setShowDModal] = useState(false);
  const [loading, setLoading] = useState(true); // State to track loading
  const [page, setPage] = useState(1);
  const [totalCount] = useState(0);

  // Initialize Logger
  const logger = useMemo(() => new Logger(getLoggerBaseURL()), []);

  const role = sessionStorage.getItem("role");;
  let permission = {};
  const permissionString = sessionStorage.getItem("permissions");
  if (permissionString) {
    permission = JSON.parse(permissionString);
  } else {
    logger.log("Permission missing", "ERROR");
  }

  const handleOrderDetailsClick = (orderId) => {
    const selectedOrder = orders.find((order) => order._id === orderId);
    setSelectedOrder(selectedOrder);
    setShowDModal(true);
  };

  useEffect(() => {
    setPage(1);
  }, [searchQuery, selectedOption, startDate, endDate]);

  // Backend already applies invoice-date + Area/Salesman (AND). Do not re-filter
  // here with creation_date — that broke Area/Salesman + date combinations.
  const filteredOrders = useMemo(() => {
    return Array.isArray(orders) ? orders : [];
  }, [orders]);

  const fetchOrders = useCallback(async (page = 1) => {
    try {
      setLoading(true);

  const params = new URLSearchParams({
        page,
        limit: 50,
        selectedOption,
        keyword: searchQuery || "",
      });
      if (startDate && endDate) {
        params.set("startDate", startDate);
        params.set("endDate", endDate);
      }

      const res = await fetch(`/api/ordera/assign/${userEmail}?${params.toString()}`);

      const json = await res.json();

      setOrders(json.data);
      setLoading(false);
    } catch (error) {
      logger.log(`Error fetching orders for email ${userEmail}: ${error.message}`, "ERROR");
      setOrders([]); // Set orders to an empty array in case of error
    } finally {
      setLoading(false); // Ensure loading state is updated even on error
    }
  }, [startDate, endDate, selectedOption, searchQuery, userEmail, logger]);

  useEffect(() => {
    fetchOrders(1);
  }, [fetchOrders, page]);

  const handleTrackDriver = (driverId) => {
    window.open(`/track?driverId=${driverId}`, "_blank");
  };

  return (
    <div className="MainAssigned">
      <Order searchQuery={searchQuery} setSearchQuery={setSearchQuery} selectedOption={selectedOption} setSelectedOption={setSelectedOption} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
      <div>
        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", }}          >
            <CircularProgress />
            <Typography variant="h6" style={{ marginTop: "20px" }}>
              Fetching data...
            </Typography>
          </div>
        ) : (
          <table className="incompleteOrdersTable">
            <thead>
              <tr>
                <th className="Ath">
                  <strong>Order No.</strong>
                </th>
                <th className="Ath">
                  <strong>Company Name</strong>
                </th>
                <th className="Ath">
                  <strong>Company Address</strong>
                </th>
                <th className="Ath">
                  <strong>Amount</strong>
                </th>
                <th className="Ath">
                  <strong>Distance</strong>
                </th>
                <th className="Ath">
                  <strong>Assign Time</strong>
                </th>
                <th className="Ath">
                  <strong>Req. Delivery Time</strong>
                </th>
                <th className="Ath">
                  <strong>Status</strong>
                </th>
                <th className="Ath">
                  <strong>Track</strong>
                </th>
                <th className="Ath">
                  <strong>Driver</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.length === 0 ? (
                <tr>
                  <td className="noOrders" colSpan="15">
                    <div className="center-content">
                      <div className="icon-wrapper">
                        <FaListUl className="icon" />
                      </div>
                      <span className="noOrdersMsg">
                        No Assigned Orders found
                      </span>
                    </div>
                  </td>
                </tr>
              ) : (
                filteredOrders.map((order) => (
                  <tr key={order._id}>
                    <td className="Atd">
                      <button className="detailsD" onClick={() => handleOrderDetailsClick(order._id)}                     >
                        <strong>{order.Order_No || "N/A"}</strong>
                      </button>
                    </td>
                    <td className="Atd">{order.Rec_Name || "N/A"}</td>
                    <td className="Atd">{order.Rec_Add || "N/A"}</td>
                    <td className="Atd">₹ {order.amount || "N/A"}</td>
                    <td className="Atd">{order.distance || "N/A"}</td>
                    <td className="Atd">{order.assign_time || "N/A"}</td>
                    <td className="Atd">{order.Del_Time || "N/A"}</td>
                    <td className="Atd">
                      {order.o_status === "0" ? (
                        <span className="unassigned">Unassigned</span>
                      ) : order.o_status === "1" ? (
                        <span className="assigned">Assigned</span>
                      ) : order.o_status === "2" ? (
                        <span className="completed">Completed</span>
                      ) : order.o_status === "3" ? (
                        <span className="completed">Incomplete</span>
                      ) : order.o_status === "4" ? (
                        <span className="Pick Up">On the way</span>
                      ) : order.o_status === "5" ? (
                        <span className="On the Way">On the way</span>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className="Atd">
                      {role === "admin" ||
                        (role === "dispatcher" && permission.locationTracking) ? (
                        order.o_status !== "0" && order.o_status !== "2" ? (
                          <button className="detailsDD" onClick={() => handleTrackDriver(order.Driv_Email)}                          >
                            Track
                          </button>
                        ) : null
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className="Atd">{order.driverName || "N/A"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem", marginRight: "30px", }}>
        <PaginationControls
          currentPage={page}
          totalItems={totalCount}
          itemsPerPage={50}
          onPageChange={setPage}
        />
      </div>
      {showDModal && selectedOrder && (
        <DetailsModal showDModal={showDModal} onClose={() => setShowDModal(false)} selectedOrder={selectedOrder} />
      )}
    </div>
  );
}

export default Assigned;